import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const ProductCard = ({ product, index = 0 }) => {
  const img1 = (product.images || [])[0];
  const img2 = (product.images || [])[1] || img1;
  return (
    <motion.div
      data-testid={`product-card-${product.slug}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ delay: (index % 6) * 0.04, duration: 0.4 }}
    >
      <Link to={`/product/${product.slug}`} className="product-card block group">
        <div className="img-wrap aspect-[4/5] bg-[#FAFAF7]">
          {img1 && (
            <img
              src={img1}
              alt={product.name}
              className="img-primary w-full h-full object-cover"
              loading="lazy"
            />
          )}
          {img2 && (
            <img
              src={img2}
              alt={`${product.name} alternate`}
              className="img-secondary w-full h-full object-cover"
              loading="lazy"
            />
          )}
          <div className="card-cta absolute inset-x-4 bottom-4 z-10">
            <div className="w-full bg-white text-black text-center py-2.5 text-[10px] tracking-[0.22em] uppercase font-semibold border border-black">
              Shop Now
            </div>
          </div>
        </div>
        <div className="pt-4 pb-2">
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#4A4A4A] mb-1">
            {product.category}
          </div>
          <h3 className="font-medium text-[15px] text-black leading-snug line-clamp-2">
            {product.name}
          </h3>
          <div className="mt-2 text-[15px] text-black font-semibold">
            ${product.price.toFixed(2)}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
